import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  root: {
    width: '594px',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    textAlign: 'left',
    paddingBottom: '12px'
  },
  buttons: {
    textAlign: 'right',
    padding: '34px 0 0',
    width: '100%'
  }
}));
